const reportWebVitals = onPerfEntry => {
  // No-op to avoid optional web-vitals dependency at build time.
  if (onPerfEntry && onPerfEntry instanceof Function) {
    return;
  }
};

export default reportWebVitals;
